import { motion } from "framer-motion";
import { Card, CardContent } from "./ui/card";

const programs = [
  {
    title: "Toddler Gymnastics",
    ageRange: "1 to 3 years",
    schedule: "Weekdays 11AM ,Weekend 10AM",
    image: "/cs1.jpeg"
  },
  {
    title: "Kintergarden",
    ageRange: "3 to 6 years",
    schedule: "Weekdays 4PM to 6PM,Weekend  11Am to 2PM",
    image: "/cs2.jpeg"
  },
  {
    title: "First Grade",
    ageRange: "7 to 14 years",
    schedule: "Weekdays 6PM to 7PM ,Weekend 3PM to 4PM",
    image: "/cs3.jpeg"
  },
];

export const Programs = () => {
  return (
    <section className="py-16 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-primary mb-4">
            Our Programs
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Join our specialized gymnastics programs designed for various age groups and skill levels.
          </p>
        </motion.div>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {programs.map((program) => (
            <motion.div
              key={program.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <Card className="group h-full overflow-hidden rounded-lg shadow-md hover:shadow-lg transition-all duration-300 bg-white">
                <div className="relative h-48 w-full">
                  <img
                    src={program.image}
                    alt={program.title}
                    className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <CardContent className="p-4">
                  <div className="space-y-2">
                    <h3 className="text-xl font-semibold text-gray-800 group-hover:text-primary transition-colors">
                      {program.title}
                    </h3>
                    <p className="text-sm font-medium text-gray-600">
                      <span className="font-semibold text-primary">Age:</span> {program.ageRange}
                    </p>
                    <p className="text-sm font-medium text-gray-600">
                      <span className="font-semibold text-primary">Schedule:</span> {program.schedule}
                    </p>
                  </div>
                </CardContent>
              </Card>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
